// types
import { AxiosError } from 'axios'
import React from 'react'
import { ToastOptions } from 'react-toastify'
import { ErrorMessagesEnum, IErrorData } from 'types/errorTypes'
import { notificator } from 'utils/notificator/notificator'

const handleError = (
  error: AxiosError,
  message?: string | JSX.Element,
  toastOptions?: ToastOptions<Record<string, never>> | undefined,
): void => {
  const errorStatus = error?.response?.status || 500
  let notificationMessage = message && !React.isValidElement(message) ? `${message} ` : ''
  switch (errorStatus) {
    case 404:
      notificationMessage += ErrorMessagesEnum.ResourceNotFound
      break
    case 401:
      notificationMessage += ErrorMessagesEnum.NotAuthenticated
      break
    case 400:
      notificationMessage += ErrorMessagesEnum.BadRequest
      break
    default:
      if (React.isValidElement(message)) {
        notificator.notify({ heading: message, type: 'error', toastOptions })
        //notificator.error(message, toastOptions)
        return
      }
      notificationMessage += ErrorMessagesEnum.Unknown
  }
  notificator.notify({ heading: notificationMessage, type: 'error', toastOptions })

  //notificator.error(notificationMessage, toastOptions)
}

export const parseErrorDetails = (error: any) => {
  const status: number = error?.response?.status || error?.status || 500
  const statusMessage: string = {
    404: ErrorMessagesEnum.ResourceNotFound,
    401: ErrorMessagesEnum.NotAuthenticated,
    400: ErrorMessagesEnum.BadRequest,
    500: ErrorMessagesEnum.SomethingWentWrong,
  }[status]!

  const errorDetails: IErrorData = error?.response?.data ? error.response.data : null

  return {
    status,
    statusMessage,
    errorDetails,
  }
}

export const errorToErrorBoxProps = (error: any, message?: string) => {
  const { status, statusMessage, errorDetails } = parseErrorDetails(error)
  return {
    title: status,
    message: message ? `${message} ${statusMessage}` : statusMessage,
    details: errorDetails,
  }
}

export const errorHandler = { handleError, errorToErrorBoxProps, parseErrorDetails }
